import * as React from "react";
import { PureComponent, Fragment } from "react";
import { Row, Container } from "react-bootstrap";
import { BsArrowLeft} from "react-icons/bs";
import logo from "../../images/logopng.png";
import "../../styles/BoatReceipt.scss";
import _, { forEach } from "lodash";
import { withSnackbar } from "notistack";
import { subDirectory } from "../../config.json";
import { AddNotification } from "../Methods/Notificaition";
import NavBar from "../common/forms/NavbarCopy";
import { getBoatBookedTicket, getBoatOtherTicket, getbookReceiptData, getprintInstructionData, getReceiptMail, getOnlyOtherService, getQrBoat,getDownloadReceipt } from "../../services/PrintReceipt";
import { getLocalStorageValues, getCookieData } from "../../services/boat";
import { format } from "date-fns";
import ttdc_tlogo from "../../images/ttdc_tlogo.png";
import { SkReceiptCard, SKBulkReceipt, SKInstruction } from "../common/skeleton/subcatCardSkeleton";
import { generateBordingPass, generateBordingPassNext } from "../../services/bordingPassService";
import { BsDownload } from "react-icons/bs";
import { MdPrint } from "react-icons/md";
import {QRCode} from "react-qr-code";
import CryptoJS from 'crypto-js';


class BoatReceipt extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      boatbooked: [],
      BoatOtherTicket: [],
      BookingBulkData: [],
      PrintBoatIns: [],
      PrintOtherIns: [],
      GSTNo: "",
      loading: false,
      isReceiptLoading: true,
      isReceiptAvailable: false,
      isFacilityLoading: true,
      isFacilityAvailable: false,
      isBulkLoading: true,
      isBulkAvailable: false,
      isInstructionLoading: true,
      isInstructionAvailable: false,
      base64Image:null,
      conversionError:null,
      
    };
  }

 
  
  decryptedValuesFun = (value) => {
    if (!value) {
      return null;
    } else {
      value = value.replace(/-/g, '+').replace(/_/g, '/');
      const decrypted = CryptoJS.AES.decrypt(value, "1d207344b9238202821030788db04eae6526857bf49bf7620303e33756503131").toString(CryptoJS.enc.Utf8);
      if (decrypted) {
        return JSON.parse(decrypted);
      }
    }
  }
  
  
  componentDidMount = async () => {
    await this.setState({ loading: true });
    
    await this.fetchImage();
    

    const params = new URLSearchParams(this.props.location.search);

    if (params) {
      // console.log("params",params.get("BoatHouseId"),params.get("BookingId"),params.get("BookingDate"),params.get("BookingType"))
      const BoatHouseId = this.decryptedValuesFun(params.get("BHId"));
      const BookingId = this.decryptedValuesFun(params.get("BId"));
      const BookingDate = this.decryptedValuesFun(params.get("BD"));
      const BookingType = this.decryptedValuesFun(params.get("BT"));
      // const OrderId = params.get("OrderId");
      await this.setState({ BookingId, BoatHouseId, BookingDate, BookingType });
      // if (this.props.history.location.state != undefined) {
      //   await this.setState({
      //     BoatHouseId: this.props.history.location.state.BoatHouseId,
      //     BookingDate:moment(this.props.history.location.state.startDate).format("DD/MM/YYYY"),
      //     BookingId: this.props.history.location.state.BookingId
      //   })
      // }
      if (BookingType == "B" || BookingType == "R") {
        await this.getBoatBookedTicket();
        await this.getBoatOtherTicket();
        // await this.getbookreceiptdata();
        await this.getprintinstruction();

        // await this.getSendMail();
      } else if (BookingType == "I") {
        this.getOnlyOtherServiceData();
        await this.getprintinstruction();
      }
      // await this.getSendMail();
    } else {
      this.props.history.push({
        pathname: `${subDirectory}/boat`,
      });
    }
    await this.setState({ loading: false });
  };
  

  getOnlyOtherServiceData = async () => {
    // await this.setState({isReceiptLoading:true})
    let data = {
      BookingId: this.state.BookingId,
      BoatHouseId: this.state.BoatHouseId,
      BookingType: this.state.BookingType,
    };
    const res = await getOnlyOtherService(data);

    if (res.data.StatusCode === 1) {
      return this.setState({ BoatOtherTicket: res.data.Response, isBulkLoading: false, isBulkAvailable: false, isReceiptLoading: false, isReceiptAvailable: false, isFacilityLoading: false, isFacilityAvailable: true });
    } else {
      return this.setState({ BoatOtherTicket: [], isBulkLoading: false, isBulkAvailable: false, isFacilityLoading: false, isFacilityAvailable: false, isReceiptLoading: false, isReceiptAvailable: false });
    }
  };

  getBoatBookedTicket = async () => {
    let data = {
      BookingId: this.state.BookingId,
      BoatHouseId: this.state.BoatHouseId,
    };
    const res = await getBoatBookedTicket(data);

    if (res.data.StatusCode === 1) {
      await this.setState({ boatbooked: res.data.Response, isReceiptLoading: false, isReceiptAvailable: true });
      let Boatdetails = res.data.Response;
      if (Boatdetails?.[0]?.BookingDate) {
        await this.setState({ BookingDate: Boatdetails?.[0]?.BookingDate });
      }
      if (this.state.BookingDate === format(new Date(), "dd/MM/yyyy")) {
        const resb = await generateBordingPassNext(data);
        if (resb.data.StatusCode === 1) {
          const resp = await generateBordingPass(data);
          if (resp.data.StatusCode === 1) {
            this.setState({ boatbooked: resp.data.Response });
          } else {
            this.setState({ boatbooked: [] });
          }
        }
      }
    } else {
      return this.setState({ boatbooked: [], isReceiptLoading: false, isReceiptAvailable: false });
    }
    await this.getbookreceiptdata();
  };
  // getSendMail = async () => {
  //   let data = {
  //     BookingId: this.state.BookingId,
  //     BoatHouseId: this.state.BoatHouseId,
  //     EmailId: getLocalStorageValues("EmailId"),
  //   }
  //   console.log(data)
  //   const res = await getReceiptMail(data);
  //   console.log(res)

  // }

  getBoatOtherTicket = async () => {
    let data = {
      BookingId: this.state.BookingId,
      BoatHouseId: this.state.BoatHouseId,
      BookingType: "B",
    };
    const res = await getBoatOtherTicket(data);

    if (res.data.StatusCode === 1) {
      return this.setState({ BoatOtherTicket: res.data.Response, isFacilityLoading: false, isFacilityAvailable: true });
    } else {
      return this.setState({ BoatOtherTicket: [], isFacilityLoading: false, isFacilityAvailable: false });
    }
  };

  getbookreceiptdata = async () => {
    let data = {
      QueryType: "BoatPrintTicketBulkReceipts",
      ServiceType: "B",
      UserId: getLocalStorageValues("UserId"),
      // "UserId":"500020",
      BookingDate: this.state.BookingDate,
      BookingId: this.state.BookingId,
      BoatHouseId: this.state.BoatHouseId,
    };

    const res = await getbookReceiptData(data);

    if (res.data.Table?.length >= 1) {
      this.setState({ BookingBulkData: res.data.Table });
      this.setState({ GSTNo: res.data?.Table?.[0]?.GSTNumber, isBulkLoading: false, isBulkAvailable: true });
    } else {
      this.setState({ BookingBulkData: [], isBulkLoading: false, isBulkAvailable: false });
    }
  };


  
 
   
  downloadContent = async () => {
    try {
      let data = {
        BookingId: this.state.BookingId,
        BoatHouseId: this.state.BoatHouseId,
        BookingType: this.state.BookingType,
      };
      await getDownloadReceipt(data);
      
      
    } catch (error) {
      console.error('Error converting HTML to PDF:', error);
    }
  };
  
    printContent = async () => {
      var printStyle = `<style>
      @media print {
        body * {
          font-family: Roboto !important;
        }
      }
      .receipt {
        background-color: white;
        border-radius: 17px;
        padding: 0% 5%;
      }
      
      .receipt-header {
        padding: 2rem 1rem 1rem 0rem;
      }
      
      .hotelbooking {
        text-align: right;
        font-size: 10px !important;
      }
    
      .logo {
        width: 220px;
        padding-left: 20px;
        padding-top: 15px;
      }
      .bbt{
        font-size:14px !important 
      }
      .bbt-d{
        font-size:10px !important
      }
      .bbt-n{
        font-size:12px !important
      }

      .obbt{
        font-size:14px !important 

      }
      .obbt-d{
        font-size:10px !important
      }
      .obbt-n{
        font-size:12px !important
      }
      
      
      .img-info-header {
        margin: 0 0rem;
      }
      .img-info {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        margin-left: -9%;
      }
      .r-head {
        text-align: center;
        font-size: 21px;
        
      }
      .star {
        padding: 0.5rem;
        font-size: 19px;
        text-align: $text-align;
      }
      .rr-1 {
        margin: 1rem 0.7rem;
        justify-content: center;
      }
      .onpayment1{
        float:left;
      }
      .r-details {
        font-size: 13px;
        line-height:1.5;
        
      }
      .rpin{
        font-size:18px !important;
      }
      .hr1 {
        width: 100%;
        margin-left: 0px;
        color: white;
        background-color: white;
        border: 0px;
        height: 0px;
        border-top: 1px dashed gray;
      }
      .hr1:after {
        display: inline-block;
        position: relative;
        top: -13px;
        left: 50%;
        padding: 0 2px;
        background: white;
        color: gray;
        font-size: 15px;
      }
      .receiptdiv{
        text-align: center;
        font-weight: 600;
        font-size: 14px;
      }
      .table-text{
        font-size: 13px;
        color: #272b41;
        font-weight:500;
        margin-bottom: 8px;
        display: block;
      }
      .table-text-net{
        font-size:15px;
        font-weight:600
      }

      .table-item {
        display: block; 
        page-break-inside: avoid;
      }
      .inst-div{
        padding:0rem 0.4rem 
      }
      .inst-txt{
        font-size:9px 
      }

      @media print {
        .table-item .row {
            display: block; 
            margin-right: 0;
            margin-left: 0;
        }
        
        .table-item .col {
            display: block; 
            width: 100%; 
            max-width: 100%; 
            padding-right: 0;
            padding-left: 0;
        }
      
      
      </style>`
      var content = document.getElementById('Pdfbodydownload');
      if (content) {
          var pri = document.getElementById("ifmcontentstoprint").contentWindow;
          pri.document.open();
          pri.document.write(printStyle);
          pri.document.write(content.innerHTML);
          pri.document.close();
          pri.focus();
          pri.print();
          return true
      }
    }
  fetchImage = async () => {
    try {
      const base64 = await this.imageUrlToBase64(logo);
      this.setState({ base64Image: base64 })
    } catch (error) {
      this.setState({ conversionError: error.message || 'Error converting image' })
    }
  }

  imageUrlToBase64 = async (url) => {
    try {
      const response = await fetch(url);
      const blob = await response.blob();
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onloadend = () => resolve(reader.result);
        reader.onerror = reject;
        reader.readAsDataURL(blob);
      });
    } catch (error) {
      console.error('Error fetching or converting image:', error);
      throw error;
    }
  };
  getprintinstruction = async () => {
    let data = {
      ServiceType: "1",
      BoatHouseId: this.state.BoatHouseId,
    };
    let isdata1 = false;
    let isdata2 = false;
    const res = await getprintInstructionData(data);

    if (res.data.StatusCode === 1) {
      if (res.data.Response.length > 0) {
        this.setState({ PrintBoatIns: res.data.Response });
        isdata1 = true;
      }
    } else {
      this.setState({ PrintBoatIns: [] });
      isdata1 = false;
    }

    let data2 = {
      ServiceType: "2",
      BoatHouseId: this.state.BoatHouseId,
    };
    const res2 = await getprintInstructionData(data2);

    if (res2.data.StatusCode === 1) {
      if (res2.data.Response.length > 0) {
        this.setState({ PrintOtherIns: res2.data.Response, isInstructionLoading: false, isInstructionAvailable: true });
        isdata2 = true;
      }
    } else {
      this.setState({ PrintOtherIns: [], isInstructionLoading: false, isInstructionAvailable: false });
      isdata2 = true;
    }

    if (isdata1 || isdata2) {
      await this.setState({ isInstructionLoading: false, isInstructionAvailable: true });
    } else {
      await this.setState({ isInstructionLoading: false, isInstructionAvailable: false });
    }
  };

  reload = () => {
    this.props.history.push({
      pathname: `${subDirectory}/boat`,
    });
  };
  render() {
    const { Galleryimg0, FFtax, BookingId, CheckinDate, CheckoutDate, Adults, Place, HotelName, Difference_In_Days, finalAmount, Child, BookingDetails, BoatHouseId } = this.state;
    const { isReceiptLoading, isReceiptAvailable, isFacilityAvailable, isFacilityLoading, isBulkLoading, isBulkAvailable, isInstructionLoading, isInstructionAvailable,base64Image,conversionError } = this.state;

    return (
      <Fragment>
        <AddNotification visible={this.state.openNotification} variant={this.state.variant} message={this.state.message} onClose={() => this.setState({ openNotification: false })} />
        <div class="">
          <NavBar {...this.props} />
          {/* <Loader fullPage loading={this.state.loading} /> */}
          <div class="hotelReceipt">
            <div className="d-flex hotelReceipt-wrapper ">
              {this.state.BookingBulkData?.length >= 1 || this.state.BoatOtherTicket?.length > 0 || this.state.boatbooked?.length > 0 ? (
                <Container fluid className="hotelReceipt-con  py-2">
                  <div className="initialpage">
                    <div
                      onClick={() => {
                        this.props.history.push(`${subDirectory}/boatBookingHistory`);
                      }}
                      style={{ cursor: "pointer" }}
                    >
                      <BsArrowLeft className="ml-2 mr-2" />
                      Go to Booking History
                    </div>
                    <div className="initialprint">
                      <div onClick={this.downloadContent}>
                        <BsDownload  size={30}  style={{cursor:"pointer",color:"white"}}/>
                      </div>
                      <div onClick={this.printContent}>
                        <MdPrint size={30}  style={{cursor:"pointer",color:"white"}}/>
                      </div>
                    </div>
                    
                  </div>
                  <div class="receipt" id="Pdfbodydownload">
                    
                      <div style={{display:'flex', flexDirection:'row', justifyContent:'center', alignItems:'center', flexWrap:'wrap', columnGap:'2rem'}} className="receipt-header">

                      <div style={{display:'flex', flexDirection:'column'}} >
                        {base64Image ? (
                            <div>
                              <img
                                  id="base64ImageId"
                                  src={base64Image}
                                  alt="logo"
                                  class="logo"
                                  onError={(e) => console.error('Image error:', e)}
                                />
                            </div>
                        
                        ) : null}
                        
                        </div>

                        <div style={{display:'flex', flexDirection:'column'}}>
                          <div>
                          <div style={{fontSize:"clamp(1rem, 2.5vw, 1.4rem)"}} class="hotelbooking">THANK YOU FOR BOOKING ! </div>
                          </div>
                        </div>

                      </div>
 

                    {isReceiptLoading && <SkReceiptCard />}

                    <>
                      {this.state.boatbooked.map(
                        (i, j) =>
                          !isReceiptLoading &&
                          isReceiptAvailable && (
                            <>
                              


                              <div className="img-info-header" style={{display:'flex',justifyContent:'space-between' ,alignItems:'center' }}>

                              <div className="p-0">
                                  <div className="mobqr" style={{position:'relative'}} >
                                    <QRCode value={`${BoatHouseId};${i.BookingId};${i.BoatReferenceNo};${i.BookingPin}`}  size="100" /> 

                                    <div  style={{position:'absolute', bottom:'40px', left:'40px'}}>
                                      <img src={ttdc_tlogo} width={20} /> 
                                    </div>
                                  </div>
                                </div>

                                <div style={{display:'flex',justifyContent:'space-around', width:'70%' }}>

                                  <div >
                                  <div style={{fontSize:' clamp(1rem, 2.5vw, 1.6rem)', fontWeight:'600', textAlign:'center'}} className="bbt" >{i.BoatHouseName 
    ?.toLowerCase()
    ?.includes("boat")
      ? "Boat Booking Ticket"
      : "Booking Ticket"}</div>
                                    <div  style={{fontSize:' clamp(1rem, 2.5vw, 1.3rem)', fontWeight:'600', textAlign:'center'}} className="bbt-d"  >{i.BookingDate}</div>
                                    {this.state.BookingType == "R" && i.RescheduledDate !== "-" && i.RescheduledDate && <div class="star p-0">Rescheduled Date : {i.RescheduledDate}</div>}
                                    <div  className="bbt-n"  style={{fontSize:' clamp(1rem, 2.5vw, 1.6rem)', fontWeight:'600', textAlign:'center'}}>{i.BoatHouseName}</div>
                                  </div>

                                  <div>  
                                  </div>

                                </div>

                              </div>
                              <div className="rr-1">
                                <div className="inlinerec my-1" style={{display:'flex', justifyContent:'space-between', flexWrap:'wrap', rowGap:'1rem'}}>
                                  
                                  <div className=" ">
                                    <div>
                                      <div class="r-details">Order Id : {i.OrderId}</div>
                                      <div class="r-details">Booking Id : {i.BookingId}</div>
                                      <div class="r-details">Booked Date : {i.BookedDate ? i.BookedDate : new Date().toLocaleDateString('en-GB')}</div>
                                      <div class="r-details">
                           {i.BoatHouseName 
    ?.toLowerCase()
    ?.includes("boat")?             "Booked Boat":"Booked Slot"} : {i.BoatType}-{i.SeaterType}
                                      </div>
                                      <div class="r-details">Duration : {i.BookingDuration}(Mins)</div> 

                                    </div>
                                  </div>
                                   
                                  <div>
                                    <div className=" ">
 
                                    <div class="r-details rpin"> PIN : {i.BookingPin}</div>
                                      <div class="r-details">Bank Name : {i.BankName}</div>
                                      <div class="r-details">Bank ReferenceNo : {i.BankReferenceNo}</div>
                                      <div class="r-details">Time Slot : {i.TimeSlot}</div>

                                      <div class="r-details">Amount : ₹ {i.InitNetAmount}</div>
 

                                    </div>
                                  </div>


                                </div>

                                <hr className="hr1" />
                              </div>

                            </>
                          )
                      )}
                      {this.state.BoatOtherTicket.map(
                        (i, j) =>
                          !isFacilityLoading &&
                          isFacilityAvailable && (
                            <>
                              <div className="img-info-header"   style={{display:'flex',justifyContent:'space-between' ,alignItems:'center', columnGap:'2rem' }}>
                              <div className="p-0">
                                  <div className="mobqr" style={{position:'relative'}} >
                                  <QRCode value={`${i.BookingId};${i.ServiceId};${i.BookingType == "With Boat Booking" ? "B" : "I"}`}  size="100" /> 

                                    <div  style={{position:'absolute', bottom:'40px', left:'40px'}}>
                                      <img src={ttdc_tlogo} width={20} /> 
                                    </div>
                                  </div>
                                </div>

                                <div style={{display:'flex',justifyContent:'space-around', width:'80%' }}>

                                    <div  className="img-info">
                                    <div  style={{fontSize:' clamp(1rem, 2.5vw, 1.6rem)', fontWeight:'600'}} className="obbt">Other Facilities Ticket</div>
                                      <div  style={{fontSize:' clamp(1rem, 2.5vw, 1.3rem)', fontWeight:'600'}}  className="obbt-d">{i.BookingDate}</div>
                                      {this.state.BookingType == "R" && i.RescheduledDate !== "-" && i.RescheduledDate && <div class="star p-0">Rescheduled Date : {i.RescheduledDate}</div>}

                                      <div className="obbt-n" style={{fontSize:' clamp(1rem, 2.5vw, 1.6rem)', fontWeight:'600', textAlign:'center'}}  >{i.BoatHouseName}</div>
                                    </div>

                                </div>

                              </div>

                              <div className="rr-1">
                                <div   className="inlinerec my-1" style={{display:'flex', justifyContent:'space-between', flexWrap:'wrap',rowGap:'1rem'}}>
                                  <div className=" ">
                                    <div>
                                    
                                      <div>
                                        <div class="r-details">Order Id : {i.OrderId}</div>
                                        <div class="r-details">Booking Id : {i.BookingId}</div>
                                        <div class="r-details">Booked Date : {i.BookedDate ? i.BookedDate : new Date().toLocaleDateString('en-GB')}</div>
                                        <div class="r-details">Facility : {i.ServiceName}</div>
                                        <div class="r-details">No of Tickets : {i.NoOfItems}</div>

                                       
                                      </div>
                                    </div>
                                  </div>
                                  <div>
                                    <div className=" ">
                                      {/* <div className="receiptid"><h5 class="r-details">Booking Type:{i.PremiumStatus} </h5> */}
                                      <div class="r-details">Bank Name : {i.BankName}</div>
                                      <div class="r-details">Bank ReferenceNo : {i.BankReferenceNo}</div>
                                      <div class="r-details">Amount : ₹ {i.NetAmount}</div>
                                      {/* <div class="r-info">{i.CustomerMobile}</div> */}
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <hr className="hr1" />
                            </>
                          )
                      )}
                    </>

                    {isBulkLoading && <SKBulkReceipt viewBox="0 0 450 500" />}

                    {!isBulkLoading &&
                      isBulkAvailable &&
                      this.state.BookingBulkData?.map((bdata) => (
                        <>
                          <div className="rr-1">
                            <div style={{ textAlign: "center",fontSize:"clamp(1rem, 2.5vw, 1.6rem)",fontWeight:600 }}>
                              {bdata.BoatHouseName}
                            </div>
                            <div style={{ textAlign: "center",fontWeight:600,fontSize:"clamp(1rem, 2.5vw, 1.3rem)"}}>{bdata.BookingDate}</div>
                            <div style={{ textAlign: "center",fontWeight:600,fontSize:"clamp(1rem, 2.5vw, 1.3rem)" }}>Booking : {bdata.PremiumStatus}</div>
                            <div style={{ textAlign: "center",fontWeight:600,fontSize:"clamp(1rem, 2.5vw, 1.3rem)" }}>Booking Id : {bdata.BookingId}</div>
                            <div className="receiptdiv" style={{ textAlign: "center",fontWeight:600,fontSize:"clamp(1rem, 2.5vw, 1.3rem)" }}>
                              Booking Receipt
                            </div>

                            <div className="receipttable" style={{padding:'2rem 0rem '}}>

                              <div className="table-item">

                                <div style={{display:'flex', justifyContent:'space-between'}}>

                                  <div>
                                    <div className="table-infor">
                                      <strong className="table-text">Payment Type</strong>
                                      <strong className="table-text">{bdata.BoatHouseName?.toLowerCase()
    ?.includes("boat") ? "Boat Charges" : "Booking Charges"}</strong>
                                      {bdata.InitRowerCharge === "0.00" ? "" : <strong className="table-text">Rower Charges</strong>}
                                      {bdata.BoatDeposit === "0.00" ? "" : <strong className="table-text">Deposit </strong>}
                                      {this.state.BoatOtherTicket.length > 0 && <strong className="table-text">Other Facilities </strong>}
                                      <strong className="table-text">GST</strong>
                                    </div>
                                  </div>

                                  <div>
                                    <div className="table-infor table-infor2">
                                      <strong className="table-text">₹ {bdata.PaymentTypeName}</strong>
                                      <strong className="table-text">₹ {bdata.InitBoatCharge}</strong>
                                      {bdata.InitRowerCharge === "0.00" ? "" : <strong className="table-text">₹ {bdata.InitRowerCharge}</strong>}
                                      {bdata.BoatDeposit === "0.00" ? "" : <strong className="table-text">₹ {bdata.BoatDeposit}</strong>}
                                      {this.state.BoatOtherTicket.length > 0 && <strong className="table-text">₹ {bdata.OtherService}</strong>}
                                      <strong className="table-text">₹ {bdata.BFDTaxAmount}</strong>
                                    </div>
                                  </div>

                                </div>

                              

                                <div className="rr-1">
                                  <div className="receipttable">
                                    <div className="table-item">
                                      <div style={{display:'flex', justifyContent:'space-between'}} >
                                        <div>
                                          <div className="table-infor">
                                            <strong className=" table-text table-text-net">NET</strong>
                                          </div>
                                        </div>
                                        <div>
                                          <div className="table-infor table-infor2">
                                            <strong className=" table-text table-text-net">₹ {parseFloat(bdata.InitNetAmount).toFixed(2)}</strong>

                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                          </div>
                          </div>

                            </div>
                          </div>
                          {/* <hr /> */}
                        </>
                      ))}
                    {isInstructionLoading && <SKInstruction viewBox="0 0 450 500" />}

                    {!isInstructionLoading && isInstructionAvailable && (
                      <>
                        {this.state.BookingBulkData.length > 0 && (this.state.BookingType == "B" || this.state.BookingType == "R") && (
                          <div className="gstin" style={{ textAlign: "center" }}>
                            GSTIN - {this.state.GSTNo}
                          </div>
                        )}

                        {(this.state.BookingType == "B" || this.state.BookingType == "R") && this.state.PrintBoatIns?.length > 0 && (
                          <>
                            <Row className="rr-1">
                              <div className="ins">Instructions</div>
                              <ul  className="inst-div"  >
                                {this.state.PrintBoatIns?.map((boatinst) => (
                                  <li className="inst-txt"  >{boatinst.InstructionDtl}</li>
                                ))}
                              </ul>
                            </Row>
                            <hr className="hr1" />
                          </>
                        )}

                        {this.state.BoatOtherTicket.length > 0 && this.state.PrintOtherIns?.length > 0 && (
                          <>
                            <div className="rr-1">
                              <div className="ins">Other Facilities Instructions</div>
                              <div>
                                <ul>
                                  {this.state.PrintOtherIns?.map((otherinst) => (
                                    <li>{otherinst.InstructionDtl}</li>
                                  ))}
                                </ul>
                              </div>
                            </div>
                            <hr className="hr1" />
                          </>
                        )}
                      </>
                    )}
                  </div>
                  
                </Container>
              ) : (
                !isReceiptLoading &&
                !isReceiptAvailable &&
                !isFacilityAvailable &&
                !isFacilityLoading &&
                !isBulkLoading &&
                !isBulkAvailable && (
                  <Container fluid className="hotelReceipt-con py-2">
                    <div class="receipt-nodata btn">No data found</div>
                  </Container>
                )
              )}
            </div>
          </div>
        </div>
      </Fragment>
    );
  }
}

export default withSnackbar(BoatReceipt);
